<template>
  <div>
    <v-card class="mx-auto mt-1" outlined width="98%">
      <v-card-title>
        <v-icon>mdi-library</v-icon>
        <span class="font-weight-black">{{satellite.property.name}}</span>
        <v-spacer></v-spacer>
        <v-btn @click="close" icon>
          <v-icon color="red">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-chip-group column>
          <div v-for="(item, key) in satellite.buildInfo" :key="key" class="caption">
            <v-chip small>
              <v-avatar left>
                <v-icon small color="grey">mdi-cog</v-icon>
              </v-avatar>
              <div>
                <span class="grey--text">{{key}}</span>:
                <span class="font-weight-bold">{{item}}</span>
              </div>
            </v-chip>
          </div>
          <v-chip small>
            <v-avatar left>
              <v-icon small color="grey">mdi-cog</v-icon>
            </v-avatar>
            <div>
              <span class="grey--text">orgId</span>:
              <span class="font-weight-bold">{{satellite.company.orgId}}</span>
            </div>
          </v-chip>
        </v-chip-group>
      </v-card-text>

      <v-divider></v-divider>
      <v-expansion-panels
        :multiple="true"
        :hover="true"
        :accordion="true"
        :focusable="true"
        class="caption"
      >
        <!--Extensions-->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-row no-gutters>
              <v-col cols="12">
                <v-chip color="light-green">
                  <v-avatar left>
                    <v-icon>mdi-puzzle</v-icon>
                  </v-avatar>
                  Extensions
                  {{Object.keys(satellite._container.extensions).length}}
                </v-chip>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-for="(extension,name,key) in satellite._container.extensions" :key="key">
              <v-expansion-panels
                :multiple="true"
                :hover="true"
                :accordion="true"
                :focusable="true"
              >
                <ExtensionsMain :extension="extension" :name="name" />
              </v-expansion-panels>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!--Rules-->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-row no-gutters>
              <v-col cols="12">
                <v-chip color="blue">
                  <v-avatar left>
                    <v-icon>mdi-sitemap</v-icon>
                  </v-avatar>
                  Rules
                  {{satellite._container.rules.length}}
                </v-chip>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-for="rule in satellite._container.rules" :key="rule.id">
              <v-expansion-panels
                :multiple="true"
                :hover="true"
                :accordion="true"
                :focusable="true"
              >
                <RulesMain v-bind:rule="rule" />
              </v-expansion-panels>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!--DataElements-->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-row no-gutters>
              <v-col cols="12">
                <v-chip color="teal">
                  <v-avatar left>
                    <v-icon>mdi-database</v-icon>
                  </v-avatar>
                  Data Elements
                  {{Object.keys(satellite._container.dataElements).length}}
                </v-chip>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-for="(dataElement,name,key) in satellite._container.dataElements" :key="key">
              <v-expansion-panels
                :multiple="true"
                :hover="true"
                :accordion="true"
                :focusable="true"
              >
                <DataElementMain :dataElement="dataElement" :name="name" />
              </v-expansion-panels>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>
<script>
import RulesMain from "./Launch/RulesMain";
import DataElementMain from "./Launch/DataElementMain";
import ExtensionsMain from "./Launch/ExtensionsMain";

export default {
  name: "LaunchViewer",
  components: {
    RulesMain,
    DataElementMain,
    ExtensionsMain
  },
  methods: {
    close() {
      this.$emit("removeLibrary");
    }
  },
  props: ["satellite"]
};
</script>
